import {
    animate,
    state,
    style,
    transition,
    trigger,
    AnimationTriggerMetadata,
} from "@angular/animations";

export const iconAnimation: AnimationTriggerMetadata = trigger(
    "expansionPanelIcon",
    [
        state(
            "hidden",
            style({
                transform: "rotate(0) translateY(0)",
            }),
        ),
        state(
            "visible",
            style({
                transform: "rotate(-180deg) translateY(-5px)",
            }),
        ),
        transition("hidden <=> visible", animate("500ms ease-in-out")),
    ],
);
